import {
  CardActions,
  CardContent,
  CardMedia,
  Card,
  Divider,
  Typography,
} from "@mui/material";
import FullScreenDialog from "components/FullScreenDialog";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import { IDistanciaEvento, IEventoResponse } from "interfaces/eventos";
import ListCatDist from "./ListCatDist";

import FormDistancia from "./FormDistancia";
import { useState } from "react";

interface Props {
  evento: IEventoResponse;
  updateEvento: () => void;
}

export type SelectedDistanciaProps = {
  type: "edit" | "create" | "clone";
  distCat: IDistanciaEvento;
};

export default function CategoriaDistancia({ evento, updateEvento }: Props) {
  const [open, setOpen] = useState<boolean>(false);
  const [selectedDistancia, setSelectedDistancia] =
    useState<SelectedDistanciaProps | null>(null);
  const imgCardEvento = evento.urlImageDestaque;
  const distCatEvento = evento.distanciaEvento;
  const lotesEvento = evento.lotesEventos;

  const handleOpenModal = () => {
    setOpen(!open);
    setSelectedDistancia(null);
  };

  const handleCloneDistCat = (distCat: SelectedDistanciaProps) => {
    setOpen(true);
    setSelectedDistancia(distCat);
  };

  return (
    <Card id="catdist" sx={{ overflow: "visible", px: 3 }}>
      <MDBox display="flex" alignItems="center" lineHeight={1}>
        <CardMedia
          component="img"
          sx={{ width: 100 }}
          image={imgCardEvento}
          alt="Card do evento"
        />
        <MDBox>
          <MDTypography variant="h5">Distancia e categorias</MDTypography>
          <MDTypography variant="button" color="text">
            Informe os detalhes das distâncias e categorias do evento.
          </MDTypography>
        </MDBox>
      </MDBox>

      <Divider />

      <CardContent sx={{ overflow: "hidden", overflowX: "auto" }}>
        <ListCatDist
          distancias={distCatEvento}
          lotesEvento={lotesEvento}
          updateEvento={updateEvento}
          selectedDistancia={handleCloneDistCat}
        />
      </CardContent>

      <CardActions>
        <FullScreenDialog
          title="Adicionar categoria"
          titleButton="Adicionar novo"
          open={open}
          handleClose={handleOpenModal}
        >
          <MDBox m={4} display="flex" justifyContent="center">
            <MDBox
              display="flex"
              flexDirection="column"
              sx={{ width: "100%", maxWidth: 1380 }}
            >
              <Typography variant="h5">
                Cadastro nova distâncias e categorias
              </Typography>
              <Typography variant="subtitle2">
                Definas as distâcias e as categorias do evento
              </Typography>

              <FormDistancia
                evento={evento}
                handleClose={handleOpenModal}
                updateEvento={updateEvento}
                selectedDistancia={selectedDistancia}
              />
            </MDBox>
          </MDBox>
        </FullScreenDialog>
      </CardActions>
    </Card>
  );
}
